var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import Checkbox from './Checkbox';
import styled from 'styled-components';
import { device } from '../../styleguide/styles/device';
var Container = styled.article(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var LabelContainer = styled.article(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  justify-content: center;\n  align-content: center;\n  cursor: pointer;\n"], ["\n  justify-content: center;\n  align-content: center;\n  cursor: pointer;\n"])));
var StyledLabel = styled.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: ", ";\n  margin-left: 15px;\n  height: 30px;\n  @media ", " {\n    font-size: 12px;\n  }\n  @media ", " {\n    font-size: 16px;\n  }\n  cursor: pointer;\n"], ["\n  font-family: ", ";\n  margin-left: 15px;\n  height: 30px;\n  @media ", " {\n    font-size: 12px;\n  }\n  @media ", " {\n    font-size: 16px;\n  }\n  cursor: pointer;\n"])), function (props) { return props.theme.fonts.secondary; }, device.mobileS, device.mobileL);
function CheckboxWithLabel(props) {
    return (React.createElement(Container, null,
        React.createElement(LabelContainer, { onClick: function () {
                if (!props.checked) {
                    var canCheck = props.allowCheck();
                    if (canCheck) {
                        props.toggleChecked(!props.checked);
                    }
                    else {
                        //pop a selected option as the user wants to switch. This should really be a radio group like functionality
                        //the id passed to the function is the id of the item you WANT TO CHECK AFTER PREVIOUS ITEM IS REMOVED
                        props.removeCheckedItem();
                    }
                }
                else {
                    props.toggleChecked(!props.checked);
                }
            } },
            React.createElement(Checkbox, { checked: props.checked, onChange: function () { } }),
            React.createElement(StyledLabel, null, props.label))));
}
export default CheckboxWithLabel;
var templateObject_1, templateObject_2, templateObject_3;
